module.exports = __webpack_public_path__ + "static/network.5d6312c2.png";